// extracted by mini-css-extract-plugin
export default {"overlay":"Banner_overlay__VDPL8","bannerimg":"Banner_bannerimg__CFV3L"};